import { useMemo } from 'react';

import dayjs from 'dayjs';
import minBy from 'lodash/minBy';

import {
  useClusters,
  useCluster,
} from '@cast/shared-cluster-context-data-access';

import { RangePicker } from 'components/date';
import { TourStep } from 'core/tour';
import {
  costOverTimeTourId,
  tourSteps,
} from 'features/cluster/cost-report/tourSteps';
import { useCostReportContext } from 'features/cost-report/hooks/useCostReportContext';
import {
  QUERY_PARAM_KEYS,
  useCostReportTimeRangeSelection,
} from 'features/cost-report/hooks/useCostReportTimeRangeSelection';

export const CostReportDateRangePicker = () => {
  const { cluster } = useCluster();
  const { clusters } = useClusters({ enabled: !cluster });
  const { initialState } = useCostReportTimeRangeSelection();
  const { rangePickerProps } = useCostReportContext();

  const minCreateDate = useMemo(() => {
    if (cluster?.id) {
      return cluster.createdAt;
    } else if (clusters) {
      if (clusters) {
        const min = minBy(clusters, (item) =>
          item.createdAt ? new Date(item.createdAt) : undefined
        );
        return min ? min.createdAt : undefined;
      }
    }
    return undefined;
  }, [clusters, cluster]);

  return (
    <TourStep
      step={tourSteps.datePicker}
      type={costOverTimeTourId}
      text="Adjust time intervals to monitor your costs."
      highlight="bubble"
      placement="top-end"
      beaconPosition={{
        top: 12,
        right: 12,
      }}
      popperSkidding={10}
    >
      <RangePicker
        startMonth={minCreateDate}
        minDate={dayjs.utc(minCreateDate).startOf('day').toISOString()}
        triggerInputProps={{
          size: 'medium',
          sx: { minWidth: '340px' },
        }}
        {...rangePickerProps}
        queryParamKeys={QUERY_PARAM_KEYS}
        initialTimezone={initialState.timeZone}
      />
    </TourStep>
  );
};
